document.addEventListener('DOMContentLoaded', () => {
  // Only if there isn't an explicit ?variant= in the URL
  if (new URLSearchParams(location.search).has('variant')) return;

  const thumbs = document.querySelectorAll(
    '.product__media-thumbnail, [data-media-thumbnail], .media-gallery [data-thumbnail]'
  );
  if (thumbs && thumbs[1]) thumbs[1].click(); // switch to 2nd image
});
